import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl26 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".white{fill:#fff;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_26",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Sign_right",
			className: "black",
			d: "M55.96,41.73l-4-14c-.12-.43-.52-.73-.96-.73h-12c-.45,0-.84.3-.96.73l-4,14c-.09.3-.03.63.16.88.19.25.49.4.8.4h8v16h4v-16h8c.31,0,.61-.15.8-.4.19-.25.25-.58.16-.88ZM36.33,41l3.43-12h10.49l3.43,12h-17.35Z"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Sign_left",
			children: [/* @__PURE__ */ _jsx("rect", {
				className: "black",
				x: 7.87,
				y: 6.53,
				width: 18.33,
				height: 35,
				rx: 4.17,
				ry: 4.17
			}), /* @__PURE__ */ _jsx("path", {
				className: "white",
				d: "M22.04,35.87c-.55,0-1-.45-1-1v-3.03l-9.83-14.75c-.11-.16-.17-.36-.17-.55v-3.33c0-.55.45-1,1-1s1,.45,1,1v3.03l9.83,14.75c.11.16.17.36.17.55v3.33c0,.55-.45,1-1,1Z"
			})]
		})]
	})]
});
export default SvgAppIcBefehl26;
